<template>
  <v-layout row wrap>
    <v-flex xs12 class="text-xs-left blue--text">
      <!--          <v-alert :value="true"  color="blue" outline  icon="info" >-->
      <div>We just sent a 4 digit code to <strong class="text-primary">{{ email }}</strong></div>
      <!--          </v-alert>-->
    </v-flex>

    <v-flex d-flex xs12 mt-4>
      <v-layout row wrap align-center class="text-xs-left">
        <v-flex xs12 class="pr-4">
          Enter the code here:
        </v-flex>

        <v-flex d-flex xs12 >
          <v-text-field
            @keyup="changedInput=true"
            @keyup.enter="validateOtp"
            v-validate="'required|length:4'"
            :error-messages="errors.collect('otp')"
            data-vv-name="otp"
            data-vv-validate-on="blur"
            v-model="otp"
            label="Code"
            type="tel"
          ></v-text-field>
        </v-flex>

        <v-flex d-flex xs12 class="mt-0">
          <v-btn @click="validateOtp"
                 :disabled="!changedInput || !otp || otp.length !== 4"
                 :loading="loading" class="ml-0 mr-0 "
                 color="success">Confirm code</v-btn>
        </v-flex>

        <v-flex d-flex xs12>
          <v-btn class="mr-0 ml-0" @click="goBack" color="primary">&#8592; Back</v-btn>
        </v-flex>

        <v-flex align-center xs7 sm6 class="text-xs-right mt-5 pt-4 pr-1">
          <em>Can't find our email?<br>Remember to check spam or junk email folders.</em>
        </v-flex>

        <v-flex xs5 sm6 class="text-xs-left mt-5 pt-4 pl-2">
          <img src="@/assets/images/tree.svg" height="80">
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CodeVerification',
  data () {
    return {
      loading: false,
      changedInput: false,
      otp: '',
      errorMsg: 'Please enter 4 digit code',
      dictionary: {
        custom: {
          otp: {
            required: () => this.errorMsg,
            length: 'Code must be 4 Digits'
          }
        }
      }
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    // eslint-disable-next-line no-console
    console.log('this.getUserDetails', this.getUserDetails)
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    email () {
      return this.decryptData(this.getUserDetails.email)
    },
    emailVerified () {
      return this.getUserDetails.email_verified
    }
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    goBack () {
      this.goToSignupStep(this.page, 'confirm-my-email')
    },
    validateOtp () {
      console.log(this.errors.otp)
      this.$validator.validateAll().then((result) => {
        if (result) {
          const otpId = this.getUserDetails.email_otp_id
          this.loading = true
          this.$http({
            url: process.env.API_URL + '/ws/userservice/verify/otp/' + otpId + '/entered/' + this.otp,
            method: 'GET'
          }).then((res) => {
            if (res.data.otpMatch === true) {
              this.setUser({...this.getUserDetails, email_verified: true})
              this.$router.push({name: 'SignUp', params: {step: 'store-verification', email: this.$route.params.email}})
            } else {
              this.setUser({...this.getUserDetails, email_verified: false})
              this.loading = false
              this.errors.add({
                field: 'otp',
                msg: 'Invalid code'
              })
            }
          })
        }
      })
    }
  },
  mixins: [crypto, common]
}
</script>


<style scoped>
.partitioned {
  padding-left: 10px;
  letter-spacing: 42px;
  border: 0;
  background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 35px;
  width: 230px;
  min-width:230px;
  outline-style:none;
  box-shadow:none;
  border-color:transparent;
}

#divInner{
  left: 0;
  position: sticky;
}

#divOuter{
  width:190px;
  overflow:hidden
}
</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/69/CodeVerification.vue